var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.warehouses),function(warehouse,idx){return _c('span',{key:warehouse.id},[_c('router-link',{attrs:{"to":{ name: 'View Warehouse', params: { id: warehouse.id } }}},[_vm._v(" "+_vm._s(`${warehouse.name}`)+" ")]),_vm._v(" "+_vm._s(_vm.warehouses.length - 1 > idx ? "," : " ")),_c('br')],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }